import { QUESTIONNAIRE_PAGE_BOX_SX } from '../../../../common';

export const GENERAL_INFORMATION_FORM_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  position: 'relative',
  textAlign: 'left',
  ...QUESTIONNAIRE_PAGE_BOX_SX,
};

export const GENERAL_INFORMATION_FORM_LOADING_OVERLAY_SX = {
  alignItems: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.65)',
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  position: 'absolute',
  zIndex: 1,
};
